<label class="toggle">
  <ng-content select="input"></ng-content>
  <span class="toggle__decor"></span>
</label>
